import React from 'react';
import _ from 'lodash';
import Spinner from '~/components/spinner';
import useDashboardSupplier from '~/view-data/use-dashboard-supplier';
import Cards from '~/views/dashboard-supplier/cards';
import DataTable from '~/components/datatable';
import { Container, TableContainer, FormHeader } from '~/views/dashboard-supplier/styles';
import { formats, distanceDates } from '~/helper';
import CellStatus from '~/components/datatable/cell-status';

function DashboardSupplier() {
  const { state, actions } = useDashboardSupplier();

  const columns = [
      {
        name: 'Evento',
        selector: 'event',
        cell: (row) => {
          let text = _.get(row, 'event.name');
          return (
            <CellStatus title={text} color={_.get(row, 'event.accreditationEndDate') > _.get(state, 'data.now') ? '#53d449' : '#e6467f'}>
              <strong>{text}</strong>
            </CellStatus>
          );
        },
      },
      {
        name: 'Local',
        selector: 'event',
        hide: 'md',
        format: (row) => _.get(row, 'event.place.name')
      },
      {
        name: 'Data do evento',
        selector: 'event',
        width: '150px',
        format: (row) => formats.dateTimeZone(_.get(row, 'event.eventDate'), 'dd/MM/yyyy HH:mm')
      },
      {
        name: 'Colaboradores credenciados',
        selector: 'event',
        width: '200px',
        format: (row) => formats.number(_.size(_.get(row, 'event.employees')))
      },
      {
        name: 'Prazo para Credenciamento',
        selector: 'event',
        width: '200px',
        format: (row) => distanceDates(_.get(row, 'event.accreditationEndDate'), _.get(state, 'data.now'), 'Encerrado')
      },
    ];

  return (
    <Container>
      {state.loading ? 
        <Spinner visible={true} />
        :
        <div className='left'>
          <Cards
            model={state.data || {}}
            goToEvents={actions.goToEvents}
            goToPersons={actions.goToPersons}
            />

          <TableContainer>
            <div className='list'>
              <FormHeader>
                Eventos disponíveis ({_.size(_.get(state.data, 'eventAvailable'))})
              </FormHeader>

              <DataTable
                columns={columns}
                data={{ rows: _.orderBy(_.get(state.data, 'eventAvailable') || [], [ 'event.accreditationEndDate' ], [ 'DESC' ]) }}
                noPagination={true}
                keyField="id"
                emptyText="Nenhum evento disponível"
                onRowClicked={actions.goToAccreditation}
                extraOptions={{
                  ignoreRowClicked: true,
                  selectableRows: false,
                  selectableRowsHighlight: false
                }}
              />
            </div>
          </TableContainer>
        </div>
      }
    </Container>
  );
}

export default DashboardSupplier;
